import { render } from "./StatViewManagerPatients.vue?vue&type=template&id=a6447cf2&scoped=true"
import script from "./StatViewManagerPatients.vue?vue&type=script&lang=js"
export * from "./StatViewManagerPatients.vue?vue&type=script&lang=js"

import "./StatViewManagerPatients.vue?vue&type=style&index=0&id=a6447cf2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6447cf2"]])

export default __exports__